'use client';

import { c as _c } from "react/compiler-runtime";
import { Frame } from '@morpho-org/ui-v6/client';
import { HelpLauncher } from '@/components/common/HelpLauncher';
import MobileNavBar from '@/components/common/MobileNavBar';
import NavBar from '@/components/common/NavBar';
import { StatusToasts } from '@/components/common/StatusToasts';
import { useTermsOfUseAccepted } from '@/contexts/TermsOfUse/TermsOfUse.context';
const OuterLayout = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const termsAccepted = useTermsOfUseAccepted();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden md:block" data-testid="nav-desktop"><NavBar /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<div className="md:hidden" data-testid="nav-mobile"><MobileNavBar /></div></>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HelpLauncher />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <Frame navBar={t2}>{children}{t3}</Frame>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== termsAccepted) {
    t5 = termsAccepted ? <StatusToasts /> : null;
    $[5] = termsAccepted;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default OuterLayout;